import React, { useEffect, useState } from 'react';
import { Image, Button } from 'react-bootstrap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import parse from 'html-react-parser';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import { useGetHomeVideosQuery } from 'services';
import { S3_URL, convertSeconds } from 'constants';
import { setModalConfig } from 'store/common';
import './styles.scss';

const IntroJobstas: React.FC = () => {
	const { data: { slider = [] } = {} } = useGetHomeVideosQuery();
	const settings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		className: 'center',
		centerMode: true,
		centerPadding: '18%',
		cssEase: 'linear',
		accessibility: true,
		focusOnSelect: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					centerPadding: '10%',
				},
			},
		],
	};
	const { translate } = useTranslate();

	const [sliderData, setSliderData] = useState([]);

	useEffect(() => {
		if (slider?.length > 0) {
			setSliderData(
				slider?.map((data: any) => {
					return {
						mediaType: 'video',
						file: data?.banner_video,
						videoThumbnail: data?.banner_video_thumb,
						title: data?.title,
						banner_video_duration: data?.banner_video_duration,
					};
				}) || [],
			);
		}
	}, [slider]);

	const onAssetsClick = (index: number) => {
		setModalConfig({
			visible: true,
			data: sliderData,
			id: index,
			type: 'carouselModal',
			props: {
				fullscreen: true,
				centered: true,
				dialogClassName: 'dialog-assets-carousel',
			},
		});
	};

	return (
		<section className="intro-jobstas py-80">
			<div className="main-heading px-3 text-center mx-auto">
				<h2 className="fw-bold">{parse(translate('Home.introJobStas'))}</h2>
				<p className="mb-0">{translate('Home.introJobStasSubTitle')}</p>
			</div>
			<div className="intro-jobstas-slider">
				<Slider {...settings} className="w-100 overflow-hidden">
					{sliderData?.length > 0 &&
						sliderData?.map((slideData: any, index: number) => {
							return (
								<div key={index} className="slide-item position-relative">
									<Image
										src={S3_URL + slideData?.videoThumbnail}
										className="w-100 h-100 object-fit-cover"
										alt={slideData?.title}
										loading="lazy"
									/>
									<div className="img-overlay position-absolute top-0 start-0 w-100 h-100"></div>
									<div className="slide-item-content d-flex align-items-center position-absolute w-100 bottom-0 gap-3">
										<div className="flex-1">
											<h4 className="text-white fw-bold">{slideData?.title}</h4>
											{slideData?.banner_video_duration > 0 && (
												<p className="text-white mb-0 d-flex align-items-center gap-1 gap-md-2">
													<i className="ri-time-fill" aria-hidden="true"></i>
													{convertSeconds(slideData.banner_video_duration)}
												</p>
											)}
										</div>
										<div>
											<Button
												onClick={() => onAssetsClick(index)}
												className="play-button bg-transparent border-0 rounded-circle p-0"
												aria-label={`Play ${slideData?.title}`}
											>
												<Image
													src={IMAGE_PATHS.PlayIcon}
													className="w-100"
													alt="player-icon"
													loading="lazy"
												/>
											</Button>
										</div>
									</div>
								</div>
							);
						})}
				</Slider>
			</div>
		</section>
	);
};

export default IntroJobstas;
